import PropTypes from 'prop-types'
import { SearchIcon, SortIcon } from '../../../../assets/svg'
import { ORGANIZER_REQUEST_STATUSES } from '../../../../assets/const'

const TABS = [
  { value: ORGANIZER_REQUEST_STATUSES.NEW, label: 'Новые' },
  { value: ORGANIZER_REQUEST_STATUSES.APPROVED, label: 'Одобрено' },
  { value: ORGANIZER_REQUEST_STATUSES.REJECTED, label: 'Отклонено' },
]

const Filters = ({ query, onQueryChange, tab, onTabChange }) => (
  <div className="mb-[1.25rem] flex flex-wrap items-center gap-[0.625rem]">
    <label className="flex w-full sm:flex-1 sm:max-w-[24.375rem] items-center gap-[0.625rem] rounded-[10px] border border-solid border-[#d9d9d9] bg-white px-[1rem] py-[0.75rem] sm:py-[0.875rem]">
      <SearchIcon />
      <input
        type="text"
        value={query}
        onChange={(e) => onQueryChange(e.target.value)}
        placeholder="Поиск по названию, месту, ответственному..."
        className="flex-1 min-w-0 bg-transparent text-[0.875rem] sm:text-[0.938rem] text-[#111827] placeholder:text-[#9ca3af] outline-none"
      />
    </label>

    <div className="flex h-[3rem] items-center gap-[0.25rem] overflow-x-auto rounded-[10px] border border-solid border-[#d9d9d9] bg-white px-[0.375rem]">
      {TABS.map(({ value, label }) => {
        const active = tab === value
        return (
          <button
            key={value}
            type="button"
            onClick={() => onTabChange(value)}
            className={`cursor-pointer shrink-0 rounded-[8px] border-0 px-[0.75rem] sm:px-[1rem] py-[0.5rem] text-[0.812rem] sm:text-[0.938rem] font-medium transition-colors ${
              active
                ? 'bg-[#f3f4f6] text-[#111827]'
                : 'bg-transparent text-[#6b7280] hover:text-[#111827]'
            }`}
          >
            {label}
          </button>
        )
      })}
    </div>

    <button
      type="button"
      className="ml-auto flex h-[3rem] w-[3rem] items-center justify-center rounded-[10px] border border-solid border-[#d9d9d9] bg-white shrink-0"
    >
      <SortIcon />
    </button>
  </div>
)

Filters.propTypes = {
  query: PropTypes.string.isRequired,
  onQueryChange: PropTypes.func.isRequired,
  tab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
}

export default Filters
